var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_651_67)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.6635 8.33466C43.1066 2.77751 36.385 0 28.5011 0C20.6171 0 13.8934 2.77751 8.33649 8.33466C2.77955 13.894 0 20.6136 0 28.5C0 36.3864 2.77955 43.106 8.33649 48.6632C13.8934 54.2203 20.615 57 28.5011 57C36.3872 57 43.1066 54.2203 48.6635 48.6632C54.2205 43.106 57 36.3843 57 28.5C57 20.6157 54.2205 13.894 48.6635 8.33466ZM31.0297 49.0921C30.3069 49.8149 29.464 50.1753 28.5011 50.1753C27.5381 50.1753 26.6931 49.8149 25.9725 49.0921C25.2497 48.3694 24.8872 47.5265 24.8872 46.5634C24.8872 45.6004 25.2497 44.7575 25.9725 44.0347C26.6931 43.3119 27.536 42.9495 28.5011 42.9495C29.4662 42.9495 30.3069 43.3119 31.0297 44.0347C31.7525 44.7575 32.1128 45.6004 32.1128 46.5634C32.1128 47.5265 31.7525 48.3694 31.0297 49.0921ZM32.1128 35.7258H24.8872V6.82258H32.1128V35.7258Z",
    fill: "#F3B000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_651_67"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 57,
    height: 57,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.5acd712837959fc8d2b3f69f12362f77.svg";
export { ForwardRef as ReactComponent };